module.exports = __webpack_public_path__ + "static/media/newIcon.1bdcb768.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newIcon.svg
// module id = 1474
// module chunks = 0